import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: '/toconfigagent',
      name: 'toconfigagent',
      component: () =>
        import(
          /* webpackChunkName: "to-configuration-agent" */ './components/ToConfigurationAgent.vue'
        ),
    },
  ],
  Module.TOCONFIGAGENT
);
